import Vue from "vue";
import Router from "vue-router";
import BasePages from "./base-pages";

//Pages
const TheContainer = () => import("@/components/containers/TheContainer");
const Dashboard = () => import("@/views/Dashboard/Dashboard");
const Parametro = () => import("@/views/Parametro/Parametro");
const Usuario = () => import("@/views/Usuario/Usuario");
const NovoUsuario = () => import("@/views/Usuario/NovoUsuario");
const TrocarSenha = () => import("@/views/Usuario/TrocarSenha");
const NovoGrupoUsuario = () => import("@/views/GrupoUsuario/NovoGrupoUsuario");
const GrupoUsuario = () => import("@/views/GrupoUsuario/GrupoUsuario");
const Permissao = () => import("@/views/GrupoUsuario/Permissao");
const SemPermissao = () => import("@/views/GrupoUsuario/SemPermissao");
const Project = () => import("@/views/Project/Project");
const NewProject = () => import("@/views/Project/NewProject");
const Inventory = () => import("@/views/Inventory/Inventory");
const NewInventory = () => import("@/views/Inventory/NewInventory");
const RepotTableInventory = () => import("@/views/Inventory/Report/TableInventory");
const Gaau = () => import("@/views/Gaau/Gaau");
const NewGaau = () => import("@/views/Gaau/NewGaau");
const RepotTableGaau = () => import("@/views/Gaau/Report/TableGaau");
const Question = () => import("@/views/Question/Question");
const NewQuestion = () => import("@/views/Question/NewQuestion");
const Geolocation = () => import("@/views/Geolocation/Geolocation");
const Transfer = () => import("@/views/Transfer/Transfer");
const Carbon = () => import("@/views/Carbon/Carbon");
const NewCarbon = () => import("@/views/Carbon/NewCarbon");
const StockCarbon = () => import("@/views/Carbon/StockCarbon")
const Pmau = () => import("@/views/Pmau/Pmau")
const PmauConfiguracao = () => import("@/views/Pmau/PmauConfiguracao")
const PmauPrompts = () => import("@/views/Pmau/PmauPrompts")
const PmauContas = () => import("@/views/Pmau/PmauContas")
const PmauPermissoes = () => import("@/views/Pmau/PmauPermissoes")
const PmauSurvey = () => import("@/views/Pmau/PmauSurvey")
const PmauWorkshop = () => import("@/views/Pmau/PmauWorkshop")
const PmauPublicHearing = () => import("@/views/Pmau/PmauPublicHearing")
const PmauActionPlan = () => import("@/views/Pmau/PmauActionPlan")
const ActionPlanPresentation = () => import("@/views/Pmau/ActionPlanPresentation")
const SurveyDashboard = () => import("@/views/Pmau/SurveyDashboard")
const SurveyFormPublic = () => import("@/views/Public/SurveyFormPublic")
const WorkshopPublic = () => import("@/views/Public/WorkshopPublic")
const WorkshopConfirmacao = () => import("@/views/Public/WorkshopConfirmacao")
const PublicHearingPublic = () => import("@/views/Public/PublicHearingPublic")
const PublicHearingPanel = () => import("@/views/Public/PublicHearingPanel")
const PublicHearingConfirmacao = () => import("@/views/Public/PublicHearingConfirmacao")
const DynamicForm = () => import("@/views/DynamicForm/DynamicForm")
const NovoDynamicForm = () => import("@/views/DynamicForm/NovoDynamicForm")
const Team = () => import("@/views/Manejo/Team")
const NewTeam = () => import("@/views/Manejo/NewTeam")
const WorkOrder = () => import("@/views/Manejo/WorkOrder")
const NewWorkOrder = () => import("@/views/Manejo/NewWorkOrder")
const WorkOrderExecution = () => import("@/views/Manejo/WorkOrderExecution")
const GeoPortal = () => import("@/views/GeoPortal/GeoPortal")




Vue.use(Router);

export default new Router({
  mode: "hash",
  linkActiveClass: "open active",
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      path: "/",
      name: "Home",
      component: TheContainer,
      redirect: "/dashboard",
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
          meta: {
            requiresAuth: true,
            permission: ""
          }
        },

        {
          path: "sem-permissao",
          name: "SemPermissao",
          meta: {
            requiresAuth: true
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: SemPermissao,
              meta: {
                requiresAuth: true
              }
            }
          ]
        },


        //Cadastro de projeto
        {
          path: "projeto",
          name: "Projeto",
          // component: projeto,
          meta: {
            requiresAuth: true,
            permission: "Projeto.Visualizar"
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: Project,
              meta: {
                requiresAuth: true,
                permission: "Projeto.Visualizar"
              }
            },
            {
              path: "editar/:id",
              name: "Editar",
              component: NewProject,
              meta: {
                requiresAuth: true,
                permission: "Projeto.Adicionar"
              }
            },
            {
              path: "novo",
              name: "Novo",
              component: NewProject,
              meta: {
                requiresAuth: true,
                permission: "Projeto.Adicionar"
              }
            }
          ]
        },

        //Geolocalização
        {
          path: "geolocalizacao",
          name: "Geolocalização",
          meta: {
            requiresAuth: true,
            permission: "Geolocalizacao.Visualizar"
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: Geolocation,
              meta: {
                requiresAuth: true,
                permission: "Geolocalizacao.Visualizar"
              }
            }
          ]
        },

        //Estoque Carvono
        {
          path: "estoque-carbono",
          name: "EstoqueCarbono",
          meta: {
            requiresAuth: true,
            permission: "Carbono.Estoque"
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: StockCarbon,
              meta: {
                requiresAuth: true,
                permission: "Carbono.Estoque"
              }
            }
          ]
        },


        //Cadastro de inventario
        {
          path: "inventario",
          name: "Inventario",
          // component: Inventario,
          meta: {
            requiresAuth: true,
            permission: "Inventario.Visualizar"
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: Inventory,
              meta: {
                requiresAuth: true,
                permission: "Inventario.Visualizar"
              }
            },
            {
              path: "editar/:id",
              name: "Editar",
              component: NewInventory,
              meta: {
                requiresAuth: true,
                permission: "Inventario.Adicionar"
              }
            },
            {
              path: "novo",
              name: "Novo",
              component: NewInventory,
              meta: {
                requiresAuth: true,
                permission: "Inventario.Adicionar"
              }
            }
          ]
        },



        //Cadastro de gaau
        {
          path: "gaau",
          name: "GAAU",
          // component: Gaau,
          meta: {
            requiresAuth: true,
            permission: "Gaau.Visualizar"
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: Gaau,
              meta: {
                requiresAuth: true,
                permission: "Gaau.Visualizar"
              }
            },
            {
              path: "editar/:id",
              name: "Editar",
              component: NewGaau,
              meta: {
                requiresAuth: true,
                permission: "Gaau.Visualizar"
              }
            },
            {
              path: "editar/:id/version/:version",
              name: "Editar",
              component: NewGaau,
              meta: {
                requiresAuth: true,
                permission: "Gaau.Visualizar"
              }
            },
            {
              path: "novo",
              name: "Novo",
              component: NewGaau,
              meta: {
                requiresAuth: true,
                permission: "Gaau.Adicionar"
              }
            }
          ]
        },


        //Cadastro de usuário
        {
          path: "usuario",
          name: "Usuário",
          // component: Usuario,
          meta: {
            requiresAuth: true,
            permission: "Usuario.Visualizar"
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: Usuario,
              meta: {
                requiresAuth: true,
                permission: "Usuario.Visualizar"
              }
            },
            {
              path: "editar/:id",
              name: "Editar",
              component: NovoUsuario,
              meta: {
                requiresAuth: true,
                permission: "Usuario.Adicionar"
              }
            },
            {
              path: "novo",
              name: "Novo",
              component: NovoUsuario,
              meta: {
                requiresAuth: true,
                permission: "Usuario.Adicionar"
              }
            },

            {
              path: "trocar-senha",
              name: "Trocar Senha",
              component: TrocarSenha,
              meta: {
                requiresAuth: true
              }
            }
          ]
        },


        //Manejo - Equipe
        {
          path: "equipe",
          name: "Equipe",
          meta: {
            requiresAuth: true,
            permission: "Equipe.Visualizar"
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: Team,
              meta: {
                requiresAuth: true,
                permission: "Equipe.Visualizar"
              }
            },
            {
              path: "novo",
              name: "Nova Equipe",
              component: NewTeam,
              meta: {
                requiresAuth: true,
                permission: "Equipe.Adicionar"
              }
            },
            {
              path: "editar/:id",
              name: "Editar Equipe",
              component: NewTeam,
              meta: {
                requiresAuth: true,
                permission: "Equipe.Editar"
              }
            }
          ]
        },


        //Manejo - Ordem de serviço
        {
          path: "ordem-servico",
          name: "OrdemServico",
          meta: {
            requiresAuth: true,
            permission: "OrdemServico.Visualizar"
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: WorkOrder,
              meta: {
                requiresAuth: true,
                permission: "OrdemServico.Visualizar"
              }
            },
            {
              path: "novo",
              name: "Nova Ordem de Serviço",
              component: NewWorkOrder,
              meta: {
                requiresAuth: true,
                permission: "OrdemServico.Adicionar"
              }
            },
            {
              path: "editar/:id",
              name: "Editar Ordem de Serviço",
              component: NewWorkOrder,
              meta: {
                requiresAuth: true,
                permission: "OrdemServico.Editar"
              }
            },
            {
              path: "execucao/:id",
              name: "Execução da Ordem de Serviço",
              component: WorkOrderExecution,
              meta: {
                requiresAuth: true,
                permission: "OrdemServico.Executar"
              }
            }
          ]
        },


        //Arborização Urbana - GeoPortal
        {
          path: "geoportal",
          name: "GeoPortal",
          component: GeoPortal,
          meta: {
            requiresAuth: true,
            permission: "GeoPortal.Visualizar"
          }
        },


        //Cadastro grupo de usuário
        {
          path: "grupo-usuario",
          name: "GrupoUsuario",
          meta: {
            requiresAuth: true,
            permission: "GrupoUsuario.Visualizar"
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: GrupoUsuario,
              meta: {
                requiresAuth: true,
                permission: "GrupoUsuario.Visualizar"
              }
            },
            {
              path: "editar/:id",
              name: "Editar",
              component: NovoGrupoUsuario,
              meta: {
                requiresAuth: true,
                permission: "GrupoUsuario.Adicionar"
              }
            },
            {
              path: "permissao/:id",
              name: "Permissão",
              component: Permissao,
              meta: {
                requiresAuth: true,
                permission: "GrupoUsuario.Permissao"
              }
            },
            {
              path: "novo",
              name: "Novo",
              component: NovoGrupoUsuario,
              meta: {
                requiresAuth: true,
                permission: "GrupoUsuario.Adicionar"
              }
            }
          ]
        },

        //Cadastro densidade carbono
        {
          path: "densidade-carbono",
          name: "DensidadeCarbono",
          meta: {
            requiresAuth: true,
            permission: "Carbono.Visualizar"
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: Carbon,
              meta: {
                requiresAuth: true,
                permission: "Carbono.Visualizar"
              }
            },
            {
              path: "editar/:id",
              name: "Editar",
              component: NewCarbon,
              meta: {
                requiresAuth: true,
                permission: "Carbono.Editar"
              }
            },
            {
              path: "novo",
              name: "Novo",
              component: NewCarbon,
              meta: {
                requiresAuth: true,
                permission: "Carbono.Adicionar"
              }
            }
          ]
        },



        //Perguntas GAAU
        {
          path: "pergunta",
          name: "Pergunta",
          meta: {
            requiresAuth: true,
            permission: "Pergunta.Visualizar"
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: Question,
              meta: {
                requiresAuth: true,
                permission: "Pergunta.Visualizar"
              }
            },
            {
              path: "editar/:id",
              name: "Editar",
              component: NewQuestion,
              meta: {
                requiresAuth: true,
                permission: "Pergunta.Editar"
              }
            }
          ]
        },



        //Relatório Tabela Inventario
        {
          path: "relatorio-inventario",
          name: "Relatorio",
          meta: {
            requiresAuth: true,
            permission: "RelatorioInventario.Visualizar"
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              meta: {
                requiresAuth: true,
                permission: "RelatorioInventario.Visualizar"
              }
            },
            {
              path: "tabela/:projectId",
              name: "Tabela",
              component: RepotTableInventory,
              meta: {
                requiresAuth: true,
                permission: "RelatorioInventario.Tabela"
              }
            },
          ]
        },


        //Relatório Tabela Gaau
        {
          path: "relatorio-gaau",
          name: "Relatorio",
          meta: {
            requiresAuth: true,
            permission: "RelatorioGaau.Visualizar"
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              meta: {
                requiresAuth: true,
                permission: "RelatorioGaau.Visualizar"
              }
            },
            {
              path: "tabela/:projectId",
              name: "Tabela",
              component: RepotTableGaau,
              meta: {
                requiresAuth: true,
                permission: "RelatorioGaau.Tabela"
              }
            },
          ]
        },

         // Trasnferência de pontos
         {
          path: "transferencia",
          name: "Transferencia",
          component: Transfer,
          meta: {
            requiresAuth: true,
            permission: "Transferencia.Visualizar"
          }
        },



        // PMAU - Ferramentas IA
        {
          path: "pmau",
          name: "PMAU",
          component: Pmau,
          meta: {
            requiresAuth: true,
            requiresPmau: true,
            pmauModules: ["criar", "resultado"],
            permission: ""
          }
        },

        // PMAU - Configurações por conta
        {
          path: "pmau-configuracao",
          name: "PmauConfiguracao",
          component: PmauConfiguracao,
          meta: {
            requiresAuth: true,
            requiresPmau: true,
            pmauModules: ["configuracao"],
            permission: ""
          }
        },

        // PMAU - Prompts (aba da conta para o técnico; aba do padrão só para o admin)
        {
          path: "pmau-prompts",
          name: "PmauPrompts",
          component: PmauPrompts,
          meta: {
            requiresAuth: true,
            requiresPmau: true,
            pmauModules: ["configuracao", "criar"]
          }
        },

        // PMAU - Habilitação do PMAU por conta (admin). Sem requiresPmau: o
        // admin precisa acessar mesmo com o PMAU desabilitado na conta atual.
        {
          path: "pmau-contas",
          name: "PmauContas",
          component: PmauContas,
          meta: {
            requiresAuth: true,
            requiresPmauAdmin: true
          }
        },

        // PMAU - Permissões por usuário × módulo (admin)
        {
          path: "pmau-permissoes",
          name: "PmauPermissoes",
          component: PmauPermissoes,
          meta: {
            requiresAuth: true,
            requiresPmau: true,
            requiresPmauAdmin: true
          }
        },

        // PMAU - Diagnóstico Participativo (Etapa 3)
        {
          path: "pmau-survey",
          name: "PmauSurvey",
          component: PmauSurvey,
          meta: {
            requiresAuth: true,
            requiresPmau: true,
            pmauModules: ["diagnostico"],
            permission: ""
          }
        },

        // PMAU - Dashboard de Apresentação do Diagnóstico
        {
          path: "pmau-survey-dashboard",
          name: "PmauSurveyDashboard",
          component: SurveyDashboard,
          meta: {
            requiresAuth: true,
            requiresPmau: true,
            pmauModules: ["diagnostico"],
            permission: ""
          }
        },

        // PMAU - Workshop Participativo
        {
          path: "pmau-workshop",
          name: "PmauWorkshop",
          component: PmauWorkshop,
          meta: {
            requiresAuth: true,
            requiresPmau: true,
            pmauModules: ["workshop"],
            permission: ""
          }
        },

        // PMAU - Audiência Pública (Etapa 14)
        {
          path: "pmau-public-hearing",
          name: "PmauPublicHearing",
          component: PmauPublicHearing,
          meta: {
            requiresAuth: true,
            requiresPmau: true,
            pmauModules: ["audiencia"],
            permission: ""
          }
        },

        // PMAU - Plano de Ação
        {
          path: "pmau-action-plan",
          name: "PmauActionPlan",
          component: PmauActionPlan,
          meta: {
            requiresAuth: true,
            requiresPmau: true,
            pmauModules: ["plano_acao"],
            permission: ""
          }
        },
        {
          path: "pmau-action-plan-presentation",
          name: "ActionPlanPresentation",
          component: ActionPlanPresentation,
          meta: {
            requiresAuth: true,
            requiresPmau: true,
            pmauModules: ["plano_acao"],
            permission: ""
          }
        },
        
        // Formulários Dinâmicos
        {
          path: "formulario-dinamico",
          name: "FormularioDinamico",
          meta: {
            requiresAuth: true,
            permission: "PerguntaDinamica.Visualizar"
          },
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "",
              component: DynamicForm,
              meta: {
                requiresAuth: true,
                permission: "PerguntaDinamica.Visualizar"
              }
            },
            {
              path: "novo",
              name: "NovoDynamicForm",
              component: NovoDynamicForm,
              meta: {
                requiresAuth: true,
                permission: "PerguntaDinamica.Adicionar"
              }
            },
            {
              path: "editar/:id",
              name: "EditarDynamicForm",
              component: NovoDynamicForm,
              meta: {
                requiresAuth: true,
                permission: "PerguntaDinamica.Editar"
              }
            }
          ]
        },

        // Parametros do sistema
        {
          path: "parametro",
          name: "Parametro",
          component: Parametro,
          meta: {
            requiresAuth: true,
            permission: "Parametro.Visualizar"
          }
        }
      ]
    },
    BasePages,
    {
      path: "/diagnostico/:token",
      name: "DiagnosticoPublico",
      component: SurveyFormPublic,
      meta: { requiresAuth: false }
    },
    {
      path: "/audiencia-publica/sugestoes/:token",
      name: "PublicHearingSuggestionsPublico",
      component: SurveyFormPublic,
      meta: { requiresAuth: false }
    },
    {
      path: "/workshop/:token",
      name: "WorkshopPublico",
      component: WorkshopPublic,
      meta: { requiresAuth: false }
    },
    {
      path: "/workshop/:token/confirmacao",
      name: "WorkshopConfirmacao",
      component: WorkshopConfirmacao,
      meta: { requiresAuth: false }
    },
    {
      path: "/audiencia-publica/painel/:token",
      name: "PublicHearingPainel",
      component: PublicHearingPanel,
      meta: { requiresAuth: false }
    },
    {
      path: "/audiencia-publica/:token",
      name: "PublicHearingPublico",
      component: PublicHearingPublic,
      meta: { requiresAuth: false }
    },
    {
      path: "/audiencia-publica/:token/confirmacao",
      name: "PublicHearingConfirmacao",
      component: PublicHearingConfirmacao,
      meta: { requiresAuth: false }
    }
  ]
});
